import makeSlice from '@web/slices/banner/sliceMaker'

const bannerSlice = makeSlice({})

export default bannerSlice.reducer
